<template>
  <button
    :class="clsx('accent-button flex align-center', { 'accent-button--disabled': disabled || isLoading })"
    :disabled="disabled || isLoading"
    v-on="$listeners"
  >
    <slot />
    <SpinnerLoader v-if="isLoading" color="#FFFFFF" class="ml-2" />
  </button>
</template>

<script>
import clsx from 'clsx';
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: { SpinnerLoader },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.accent-button {
  background-color: #FB923C;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  padding: 13px 16px;
  cursor: pointer;
  border: none;

  &--disabled {
    background-color: #cccccc;
    color: #999999;
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.7;
  }
}
</style>
